/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedExperienceLevelDropdown200,
  GetApiV1PersonSharedExperienceLevelDropdown401,
  GetApiV1PersonSharedExperienceLevelDropdown500,
  GetApiV1PersonSharedExperienceLevelDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedExperienceLevelDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedExperienceLevelDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedExperienceLevelDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedExperienceLevelDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedExperienceLevelDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedExperienceLevelDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedExperienceLevelDropdown500>;

export const getApiV1PersonSharedExperienceLevelDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedExperienceLevelDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedExperienceLevelDropdownQueryResponse>;
